import {useState} from "react";
import useMerchantPortalAxios from "../utils/axios";

const MerchantSalesAPI = () => {
    const [merchantSales, setMerchantSales] = useState(null);
    const [merchantSalesLoading, setMerchantSalesLoading] = useState(true);
    const [salesChart, setSalesChart] = useState(null);

    const MerchantPortalAxios = useMerchantPortalAxios();

    async function GetTotalSales(dateFrom, dateTo) {
        setMerchantSalesLoading(true);
        if (sessionStorage.getItem("EntityType") === "LEGALENTITY")
            return;
        const res = await MerchantPortalAxios.post(
            `/v1/Overview/GetTotalSales`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                DateFrom: dateFrom,
                DateTo: dateTo,
            }
        );
        if (res.data.Payload.totalSalesRecords) {
            setMerchantSales(res.data.Payload.totalSalesRecords);
            setSalesChart(res.data.Payload.MerchantSalesCharts);
            setMerchantSalesLoading(false);
            if (res.data.Payload.totalSalesRecords[0].TotalSales !== null) {

                sessionStorage.setItem("usdAmount", res.data.Payload.totalSalesRecords[0].TotalSales.toLocaleString('en-US'));
            } else {
                sessionStorage.setItem("usdAmount", "0")
            }

            if (res.data.Payload.totalSalesRecords[1].TotalSales !== null) {

                sessionStorage.setItem("lbpAmount", res.data.Payload.totalSalesRecords[1].TotalSales.toLocaleString('en-US'));
            } else {
                sessionStorage.setItem("lbpAmount", "0")
            }
        }

    }

    return {
        GetTotalSales,
        merchantSales,
        merchantSalesLoading,
        salesChart
    }
}

export default MerchantSalesAPI;